module.exports = __webpack_public_path__ + "img/banner001.66542383.jpg";